import { z } from "zod"

export const PurchaseOrderFileSchema = z.object({
  fileType: z.string().min(1, "Type is required"),
  description: z.string().min(1, "Description is required").max(64, "Description must not exceed 64 characters"),
  file: z
    .instanceof(File)
    .nullable()
    .refine((file) => file !== null, {
      message: "Please upload a file",
    }),
})

export const PurchaseOrderFileFormSchema = z.object({
  purchaseOrderFiles: z.array(PurchaseOrderFileSchema),
})

export type PurchaseOrderFileFormValues = z.infer<typeof PurchaseOrderFileFormSchema>
export type PurchaseOrderFileValues = z.infer<typeof PurchaseOrderFileSchema>
